import { render, staticRenderFns } from "./ContentPng.vue?vue&type=template&id=b2d2ee86&scoped=true"
import script from "./ContentPng.vue?vue&type=script&lang=js"
export * from "./ContentPng.vue?vue&type=script&lang=js"
import style0 from "./ContentPng.vue?vue&type=style&index=0&id=b2d2ee86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d2ee86",
  null
  
)

export default component.exports